import React, { useEffect, useState } from "react";
import Heading from "../../common/heading/Heading";
import "./MaimIslam.css";
import { useNavigate } from "react-router-dom";

const MaimIslam = ({  }) => {
  const navigate = useNavigate();
  const [darkMode, setDarkMode] = useState(false);
  useEffect(() => {
    const savedMode = localStorage.getItem("darkMode");
    setDarkMode(savedMode === "true"); // true or false
  }, []);
  return (
 <>
  {/* الخلفية */}
  <div className={`Maim-backgrounde ${darkMode ? "dark-mode" : ""}`}></div>

  {/* إطار الصورة والعناصر الطائرة */}
  <div className={`img-frame2Maim ${darkMode ? "dark-mode" : ""}`}>
    <div className="fly-behind">
      <span className="item pen">✏️</span>
      <span className="item book"><svg width="70" height="90" viewBox="0 0 70 90" xmlns="http://www.w3.org/2000/svg">
  <path d="M25 5h20v25l15 35c5 12-4 20-15 20H25c-11 0-20-8-15-20l15-35z"
    fill="none" stroke="#2B86D1" stroke-width="4" stroke-linejoin="round"/>
</svg>
</span>
      <span className="item pencil">🖋️</span>
      <span className="item paper"><svg width="110" height="110" viewBox="0 0 110 110" xmlns="http://www.w3.org/2000/svg">
  <path d="M30 80h50v10H30z" fill="#2B86D1"/>
  <rect x="45" y="20" width="10" height="40" fill="#2B86D1"/>
  <circle cx="50" cy="15" r="10" stroke="#2B86D1" stroke-width="4" fill="none"/>
  <path d="M60 55c20 5 25 25 10 35" stroke="#2B86D1" stroke-width="4" fill="none"/>
</svg>
</span>
    </div>
    <img
      src={darkMode ? "/images/ES/backgroud22.png" : "/images/ES/backgroud22.png"}
      className="imgt2Maim"
      alt="Maim background"
    />
  </div>

  {/* المحتوى */}
  <section className={`hero-content ${darkMode ? "dark-mode" : ""}`}>
    <div className="container">
      <div className="row">
           <Heading
          title={
            <>
              مرحبًا بك في منصة{" "}
              <span className="text-highlight"> مستر / إسلام عبدالعظيم</span>
              <br />
            لتعليم الكمياء
            </>
          }
        />
      <br/>    
      <br/>
      <br/>

        <div className="button">
          <button className="primary-btn2s" onClick={() => navigate("/LoginIslam")}>
            انضم الآن <i className="fa fa-long-arrow-alt-right"></i>
          </button>
          <button className="secondary-btn2s" onClick={() => navigate("/courses")}>
            جميع الكورسات <i className="fa fa-long-arrow-alt-right"></i>
          </button>
        </div>
      </div>

      <div className="flying-elements">
        <span className="book">📚</span>
        <span className="letter"><svg width="70" height="90" viewBox="0 0 70 90" xmlns="http://www.w3.org/2000/svg">
  <path d="M25 5h20v25l15 35c5 12-4 20-15 20H25c-11 0-20-8-15-20l15-35z"
    fill="none" stroke="#2B86D1" stroke-width="4" stroke-linejoin="round"/>
</svg>
</span>
        <span className="letter"><svg width="50" height="140" viewBox="0 0 50 140" xmlns="http://www.w3.org/2000/svg">
  <rect x="15" y="10" width="20" height="110" rx="10"
    stroke="#3A9BDC" stroke-width="4" fill="none"/>
  <rect x="17" y="70" width="16" height="48" rx="8" fill="#3A9BDC"/>
</svg>
</span>
        <span className="letter"><svg width="110" height="110" viewBox="0 0 110 110" xmlns="http://www.w3.org/2000/svg">
  <path d="M30 80h50v10H30z" fill="#2B86D1"/>
  <rect x="45" y="20" width="10" height="40" fill="#2B86D1"/>
  <circle cx="50" cy="15" r="10" stroke="#2B86D1" stroke-width="4" fill="none"/>
  <path d="M60 55c20 5 25 25 10 35" stroke="#2B86D1" stroke-width="4" fill="none"/>
</svg>
</span>
        <span className="book"><svg width="120" height="70" viewBox="0 0 120 70" xmlns="http://www.w3.org/2000/svg">
  <ellipse cx="60" cy="35" rx="50" ry="20"
    fill="none" stroke="#2B86D1" stroke-width="4"/>
  <ellipse cx="60" cy="40" rx="45" ry="15"
    fill="#3A9BDC" opacity="0.3"/>
</svg>
</span>

        <span className="book">📖</span>
        <span className="book">🪶</span>
      </div>
    </div>
  </section>
  <div className="margin"></div>
</>

  );
};

export default MaimIslam;
